import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal } from '@mui/material';

const SessionExpirationAlert: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      setShowModal(true);
    };

    // Listen for the custom event
    window.addEventListener('session-expired', handleSessionExpired);

    // Clean up
    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Modal
      open={showModal}
      onClose={() => {}} // Prevent closing without action
    >
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '4px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
      }}>
        <Alert severity="warning">
          Your session has expired. You need to refresh the page to continue using the chat assistant.
        </Alert>
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <Button variant="contained" color="primary" onClick={handleRefresh}>
            Refresh Page
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SessionExpirationAlert; 